import type { KeyData } from '@/components/Chart/types/chartData';
import type { TemplateChartSeries } from '@/types/charts';

export function findSeriesBasedOnKey(
  templateChartSeries: TemplateChartSeries[] | undefined,
  key: KeyData
) {
  return templateChartSeries?.find(templateSeries => {
    const templateSeriesSymbol = templateSeries.symbol;
    return JSON.stringify(key) === JSON.stringify(templateSeriesSymbol.key);
  });
}
